// import store from '../store'
import router from '../router'
import axios from 'axios'
import qs from 'qs'
import cookie from 'js-cookie'
import { notification, message } from 'ant-design-vue'
import store from '../store'
// import api from '../api'
import config from '../config/index.js'

/**
 * @description 获取数据
 * @param {Object} url 请求地址
 * @param {Object} param 提交的参数
 * */

// let CancelToken = axios.CancelToken
// let cancel

export default function request(url, param, method = 'post') {
  let newParam = {}
  newParam = Object.assign(
    {
      userId: store.getters.userId
    },
    param
  )
  newParam = qs.stringify(newParam)
  return new Promise((resolve, reject) => {
    axios({
      baseURL: config.baseURL,
      url,
      method: method,
      responseType: 'json',
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded;charset=UTF-8'
        // filterLoginId: store.getters.userId ? store.getters.userId : ''
      },
      withCredentials: false,
      // timeout: 5000,
      params: method === 'get' ? param : null,
      data: method === 'post' ? newParam : null
      // cancelToken: new CancelToken(c => {
      //   cancel = c
      // })
    })
      .then(response => {
        if (response.data.code === 0) {
          // 每次请求重新设置token过期时间
          const date = new Date()
          cookie.set('token', date.getTime(), { expires: 3 })
          resolve(response.data)
        } else {
          if (response.data.code === 101) {
            message.warning(response.data.message)
            localStorage.clear()
            cookie.remove('token')
            router.push({ name: 'login' })
            reject(response.data)
          } else {
            message.warning(response.data.message)
            reject(response.data || '')
          }
        }
      })
      .catch(error => {
        // 登录信息不完整，请求取消
        if (error.message === 'login') {
          notification.warning({
            message: '重新登录',
            description: '登录信息缺失或失效，请重新登录！'
          })
          setTimeout(() => {
            window.location.reload()
          }, 1500)
        } else {
          // console.error('错误：' + error)
          notification.error({
            message: '错误',
            description: '接口错误'
          })
        }
      })
  })
}

// 请求拦截
// axios.interceptors.request.use(
//   requestConfig => {
//     // 拦截登录信息是否完整
//     if (
//       requestConfig.url !== api.LOGIN &&
//       (!cookie.get('token') || !localStorage.getItem('CSVPAUserInfo'))
//     ) {
//       message.warning('登陆已过期，请重新登陆！', '1500')
//       localStorage.clear()
//       cookie.remove('token')
//       cancel('login')
//     }
//     return requestConfig
//   },
//   err => {
//     return Promise.reject(err)
//   }
// )
